import React from 'react';
import PropTypes from 'prop-types';

const Thunder = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="Rectangle-10" width="24" height="24" fill="none" />
      <path id="Path-3" d="M16.374,19.939l5.849-8.773A.75.75,0,0,0,21.6,10H17V4.477a.75.75,0,0,0-1.374-.416L9.777,12.834A.75.75,0,0,0,10.4,14H15v5.523a.75.75,0,0,0,1.374.416Z" fill={color} fillRule="evenodd" />
      <path id="Combined-Shape" d="M4.5,5h5a1.5,1.5,0,0,1,0,3h-5a1.5,1.5,0,0,1,0-3Zm0,12h5a1.5,1.5,0,0,1,0,3h-5a1.5,1.5,0,0,1,0-3Zm-2-6h4a1.5,1.5,0,0,1,0,3h-4a1.5,1.5,0,0,1,0-3Z" fill={color} fillRule="evenodd" opacity="0.3" />
    </svg>
  );
}

Thunder.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Thunder.defaultProps = {
  color: '#6f9eff',
  width: 24,
  height: 24,
};

export default Thunder;



// WEBPACK FOOTER //
// ./src/components/Icons/Thunder.jsx